import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Wordmark } from './Wordmark';
import { LanguageSwitcher } from './LanguageSwitcher';

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const isHome = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    if (isHome) {
      e.preventDefault();
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
    // If not on home, the Link navigates to /#sectionId; HashRedirect won't catch it
    // since these are section anchors, so we navigate to / and scroll after
  };

  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: scrolled ? 'oklch(0.992 0.004 220 / 0.82)' : 'transparent',
      backdropFilter: scrolled ? 'saturate(180%) blur(14px)' : 'none',
      WebkitBackdropFilter: scrolled ? 'saturate(180%) blur(14px)' : 'none',
      borderBottom: scrolled ? '1px solid var(--line-2)' : '1px solid transparent',
      transition: 'all .2s ease',
    }}>
      <div className="container" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '18px 28px',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', color: 'var(--ink)', textDecoration: 'none' }}>
          <Wordmark size={24} />
        </Link>
        <nav style={{ display: 'flex', alignItems: 'center', gap: 28, fontSize: 14, color: 'var(--ink-2)' }}>
          <a href={isHome ? '#discover' : '/#discover'} className="nav-link" onClick={(e) => scrollToSection(e, 'discover')}>{t('nav.discover')}</a>
          <a href={isHome ? '#how' : '/#how'} className="nav-link" onClick={(e) => scrollToSection(e, 'how')}>{t('nav.howItWorks')}</a>
          <Link to="/blog" className="nav-link">{t('nav.blog')}</Link>
          <Link to="/organizers" className="nav-link">{t('nav.forOrganizers')}</Link>
          <LanguageSwitcher />
        </nav>
      </div>
    </header>
  );
};
